import { useMemo } from 'react'
import { CircularProgress, Stack, Typography } from '@mui/material'
import { useSearchParams } from 'react-router-dom'
import { useLazyGetTeamsPageQuery } from '../../../../api/teams'
import type { TGetTeamsQueryParams } from '../../../../api/types/teams'
import { TeamsList } from '../../../../components/Teams/TeamsList'
import { useTeamsWindowedPage } from '../../../../hooks/useTeamsWindowedPage'

export const TeamsAll = () => {
  const [searchParams] = useSearchParams()

  const teamsQueryArgs = useMemo<TGetTeamsQueryParams>(() => {
    const query = searchParams.get('query')?.trim() ?? ''
    const region = searchParams.get('region')?.trim() ?? ''
    const args: TGetTeamsQueryParams = {}
    if (query) {
      args.query = query
    }
    if (region && region !== 'all') {
      args.region = region
    }
    return args
  }, [searchParams])

  const resetKey = useMemo(() => JSON.stringify(teamsQueryArgs), [teamsQueryArgs])
  const [loadTeamsPage] = useLazyGetTeamsPageQuery()
  const { items, hasMore, isInitialLoading, isFetchingMore, isError, loadMore } = useTeamsWindowedPage(
    resetKey,
    loadTeamsPage,
    teamsQueryArgs,
  )

  if (isInitialLoading && items.length === 0) {
    return (
      <Stack alignItems="center" justifyContent="center" minHeight="100%">
        <CircularProgress />
      </Stack>
    )
  }

  if (isError) {
    return (
      <Typography color="error" textAlign="center" px={2}>
        Не удалось загрузить команды
      </Typography>
    )
  }

  return (
    <TeamsList
      teams={items}
      hasMore={hasMore}
      isLoadingMore={isFetchingMore}
      onLoadMore={loadMore}
    />
  )
}
